<template>
  <div class="phone-input">
    <div class="form-group" v-bind:class="{ 'has-feedback' : field.dirty }">
      <label v-bind:for="field.name" class="col-sm-4 control-label has-icon has-icon-phone">{{ field.label }} <span v-if="field.required" class="required">*</span></label>
      <div class="col-sm-8">
        <input v-bind:id="field.name" class="form-control" type="text" v-model="field.value" v-bind:name="field.name"/>
        <span class="form-validation-error" v-show="!isLength && field.dirty && !field.valid">{{ field.label }} has not been entered.</span>
        <span class="form-validation-error" v-show="!isRegex && field.dirty && !field.valid">{{ field.label }} is not a valid phone number.</span>
        <span class="fa fa-check form-control-feedback form-control-feedback-success" v-show="field.valid && field.dirty"></span>
        <span class="fa fa-remove form-control-feedback form-control-feedback-error" v-show="!field.valid && field.dirty"></span>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'PhoneInput',
  props: {
    field: {
      type: Object,
      default () {
        return {
          value: '',
          valid: false,
          dirty: false
        }
      }
    }
  },
  data () {
    return {
      isLength: false,
      isRegex: false,
      minLength: 1,
      regex: /^[0-9-()+\\s]{5,}$/
    }
  },
  ready () {
    this.validateField(this.field.value)
  },
  watch: {
    'field.value': function (newVal, oldVal) {
      this.validateField(newVal)
    }
  },
  methods: {
    validateField (val) {
      if (val) {
        this.field.dirty = true
        if (this.field.required) {
          this.isLength = this.field.valid = val.length > this.minLength
          if (this.isLength) this.isRegex = this.field.valid = new RegExp(this.regex, 'gi').test(val)
        } else {
          this.field.valid = true
        }
      } else if (this.field.required) {
        this.field.valid = false
      }
    }
  }
}
</script>



// WEBPACK FOOTER //
// PhoneInput.vue?14b70c16